const ReduceBigNumbers = ( number ) => {
    let num = number
    
    if( num === null || num === undefined ) { return num }
    
    if( typeof value === 'string' ){
        let convertedNum = parseFloat( num )
        if( !isNaN( convertedNum )) {
          num = convertedNum
        } else { return num }
      }
  
    if( num >= 1_000_000 ){
        return( num / 1_000_000 ).toFixed( 2 ) + 'M'
    }else if( num >= 1_000 ) {
        return( num / 1_000 ).toFixed( 2 ) + 'K'
    }
    
    return num.toString()
}
  
export default ReduceBigNumbers
  